// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ZowK","modalFooterButton":"ModalNotes_modalFooterButton__1Kpuk"};